import { ExternalLink } from "lucide-react";
import { BUSINESS } from "../data/site";

export default function BookingEmbed({ heightClass = "h-[75vh] min-h-[560px]" }) {
  return (
    <div className="flex flex-col" data-testid="booking-embed">
      <iframe
        src={BUSINESS.bookingUrl}
        title="Request a dumpster — Yavapai Waste Solutions online booking"
        className={`w-full border-0 ${heightClass}`}
        loading="lazy"
        allow="payment"
      />
      <p className="text-center text-xs text-slate-500 px-4 py-3 bg-white border-t border-slate-100">
        Booking powered by our secure online system.{" "}
        <a href={BUSINESS.bookingUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 font-semibold text-sky-700 hover:text-sky-800" data-testid="booking-open-external">
          Open in a new tab <ExternalLink className="h-3 w-3" />
        </a>{" "}
        or call {BUSINESS.phone}.
      </p>
    </div>
  );
}
